module.exports = __webpack_public_path__ + "img/pick5.c17629b8.png";